export default __webpack_public_path__ + "static/media/main-image.72933d7a.png";